// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import { formatGivenDate, setAgGridLicense } from '../../shared/services/common-functions';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import GroupAvailabilityTable from './components/group-availability-table';
import OptionsDropDown from '../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getGroupAvailability } from './repositories';
import { getLastWeeks } from '../../common/repositories';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class GroupAvailability extends Component {

    state = {

        lastWeeks: [],
        selectedLastWeek: '',
        results: []
    };

    constructor ( props ) {

        super( props );
        this.child = React.createRef();
        this._isMounted = false;
        setAgGridLicense();

    }

    componentDidMount = () => {

        this._isMounted = true;
        this.props.increaseCounter();
        getLastWeeks().then( response => {

            if ( this._isMounted ) {
                this.setState( {
                    lastWeeks: response
                } );
            }
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    componentWillUnmount = () => {

        this._isMounted = false;

    }

    handleWeekChange ( val ) {

        this.setState( {
            selectedLastWeek: val
        }, () => {

            this.refresh();

        } );

    }

    exportToExcel = () => {

        this.child.current.exportExcel();

    }

    refresh () {

        if ( this.state.selectedLastWeek ) {

            this.props.increaseCounter();

            const selectedLastWeekVal = this.state.lastWeeks
                .find( lastweekObj => Number( lastweekObj.weekEnding ) ===
                Number( this.state.selectedLastWeek ) )
                .weekNumber;
            getGroupAvailability( selectedLastWeekVal )
                .then( response => {

                    if ( this._isMounted ) {
                        this.setState( {
                            results: response
                        } );
                    }
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

        }

    }

    render () {

        const {
            selectedLastWeek, lastWeeks, results
        } = this.state;

        function buildLastWeekDate ( dateVal ) {

            const formattedVal = formatGivenDate( dateVal, 'YYYY-MM-DD' );
            if ( formattedVal === '2000-01-01' ) {

                return 'Inventory';

            } if ( formattedVal === '2000-02-01' ) {

                return 'Rework';

            }
            return formattedVal;

        }
        const lastWeekDates = lastWeeks ? lastWeeks.map( date => ( {
            label: buildLastWeekDate( date.weekEnding ), id: date.weekEnding
        } ) ) : [];

        const fullResults = results !== null && results.length !== 0 ?
            results : null;
        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">Group Availability</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-group-availability-top-options">
                            <div className="select-options">

                                <OptionsDropDown
                                    className="atp-group-availability-select"
                                    label="Last Week"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleWeekChange.bind( this )}
                                    optionDisplayAttributes={['label']}
                                    optionKey="id"
                                    options={lastWeekDates}
                                    placeholder="Select Week"
                                    selectedValue={selectedLastWeek}
                                    isRequired={false}
                                />

                                { selectedLastWeek && <span onClick={this.refresh.bind( this )}><i className="icon fa fa-refresh" /></span>}

                            </div>
                            <div className="export-button">
                                {selectedLastWeek && (
                                    <button className="primary-button" type="button" onClick={this.exportToExcel.bind( this )}>
                                        <span> Export to Excel </span>
                                    </button>
                                )}
                            </div>
                        </div>
                        { selectedLastWeek && fullResults && (
                            <GroupAvailabilityTable
                                results={fullResults}
                                unitCode={this.props.unit.name}
                                selectedLastWeek={selectedLastWeek}
                                lastWeeks={lastWeeks}
                                ref={this.child}
                            />
                        )}
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

GroupAvailability.displayName = 'GroupAvailability';
GroupAvailability.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( GroupAvailability ) );
